/* eslint-disable react-hooks/exhaustive-deps */
import './index.less';

import {
  Flex,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Space,
  Text,
} from '@tonic-one/react';
import { ClockIcon } from '@tonic-one/react-icons';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as ReactLink } from 'react-router-dom';
import { getLocalTime, getLocalUtcOffset, getUtcTime } from 'src/utils/time';

import { useUtcOffsetStore } from '../../../models/useUtcOffsetModel';
import { useTextButtonStyle } from '../style';
import { useTimeZoneStyle } from './style';
import { isInUIC } from '@Utils/common';

dayjs.extend(utc);

function TimeZone() {
  const { t } = useTranslation();
  const offsetModel = useUtcOffsetStore();
  const timeZoneProps = useTimeZoneStyle();
  const textButtonStyle = useTextButtonStyle();
  const offset = localStorage.getItem('casUtcOffset');
  useEffect(() => {
    if (!isInUIC() && !offset) {
      const localUtcOffset = getLocalUtcOffset();
      offsetModel.setUtcOffset(localUtcOffset);
    }
  }, []);

  const dateFormat = t('common.momentDateFormat') + '(UTCZ)';
  const timeRef = useRef<any>(null);
  const [date, setDate] = useState(() => {
    return getUtcTime('', offsetModel.offset, dateFormat);
  });

  useEffect(() => {
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    timeRef.current = setInterval(() => {
      setDate(getUtcTime('', offsetModel.offset, dateFormat));
    }, 1000);
  }, [offsetModel.offset]);

  useEffect(() => {
    return () => {
      if (timeRef.current) {
        clearInterval(timeRef.current);
      }
    };
  }, []);

  return (
    <Popover arrow={false} trigger="hover">
      <PopoverTrigger>
        <Flex
          align="center"
          justify="center"
          cursor="pointer"
          fontSize="14px"
          {...timeZoneProps}
          {...textButtonStyle}
        >
          <Icon mr="5px" as={ClockIcon} />
          <Text minWidth="240px">{date}</Text>
        </Flex>
      </PopoverTrigger>
      <PopoverContent>
        <PopoverBody>
          <Text fontSize="14px" padding="5px 10px">
            {t('header.timeZone.currentConsoleTime')}:<Space width="1x" />
            {getUtcTime(
              '',
              offsetModel.offset,
              t('common.momentDateFormat') + '(UTCZ)'
            )}
          </Text>
          <Text fontSize="14px" padding="5px 10px">
            {t('header.localTime')}:<Space width="1x" />
            {getLocalTime(t('common.momentDateFormat') + '(UTCZ)')}
          </Text>
          <Text size="xs" padding="5px 10px">
            <ReactLink
              to="/console-setting"
              className="timezone-title"
              data-track="CasHeader.consoleSetting"
            >
              {t('header.consoleSetting.router.title')}
            </ReactLink>
          </Text>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default TimeZone;
